export default __webpack_public_path__ + "static/media/2015.66780d66.png";